module.exports = __webpack_public_path__ + "img/372-91b9b4.png";